export default "__VITE_ASSET__BmWiUnZE__"